'use client'
import WhyForm from '@/components/landing/desktop/why/WhyForm'
import { useSearchParams } from 'next/navigation';
import React from 'react'


const BookingFormPage = () => {
   const params = useSearchParams()
    const title = params.get("title")
    return (
        <section className="grid grid-cols-1 sm:grid-cols-2 bg-skillsewa-primary rounded p-8 gap-10 h-screen place-items-center">
            <div className="flex flex-col gap-4 text-zinc-50">
                <header className="flex flex-col gap-4">
                    <h2 className="text-s-lg">
                        हामी नै किन
                    </h2>
                    <p>
                        Skill Sewa is Nepal's first home inspection company, offering a
                        range of services like interior designing, renovation, construction,
                        house designing, waterproofing, and more. Here's why Skill Sewa is
                        your one-stop solution for home improvement:
                    </p>
                </header>
                <ul className="flex flex-col gap-4">
                    <li>
                        <h3 className="text-s-md">1. Comprehensive Services </h3>
                        <p className="pl-6">
                            Skill Sewa covers all aspects of home improvement under one roof.
                        </p>
                    </li>
                    <li>
                        <h3 className="text-s-md">2. Expertise and Experience</h3>
                        <p className="pl-6">
                            {" "}
                            Our skilled professionals deliver top-notch results based on
                            extensive industry knowledge.
                        </p>
                    </li>
                    <li>
                        <h3 className="text-s-md">3. Quality Assurance</h3>
                        <p className="pl-6">
                            Skill Sewa ensures high-quality workmanship and uses superior
                            materials.
                        </p>
                    </li>
                    <li>
                        <h3 className="text-s-md">4. Customer Satisfaction</h3>
                        <p className="pl-6">
                            Satisfaction They value your vision, involve you in
                            decision-making, and strive to exceed your expectations.
                        </p>
                    </li>
                    <li>
                        <h3 className="text-s-md">5. Convenience and Efficiency</h3>
                        <p className="pl-6">
                            Efficiency Skill Sewa manages the entire process, saving you time
                            and effort.
                        </p>
                    </li>
                </ul>
            </div>
            <div className="h-fit w-full flex items-center justify-center">
                <WhyForm title={title}/>
            </div>
        </section>
    )
}

export default BookingFormPage